import { ExclamationCircleIcon } from '@heroicons/react/20/solid';
import { Text } from '@northladder/i18n';
import { TTextLocalized } from '@northladder/utilities';

import { translations } from '../../../translations';

interface IImageUploadErrorProps {
  error: TTextLocalized;
  onRetry: () => void;
}

/**
 * -----------------------------------------------------------------------------
 * Renders simple badge/pill/label with a loading indicator and text indicating
 * the current image is has failed and prompting the user to retry.
 */
export function ImageUploadError({ error, onRetry }: IImageUploadErrorProps) {
  return (
    <button
      className="
        absolute right-4 top-4 z-[100] inline-flex
        items-center rounded-full bg-red-100 px-4 py-0.5 text-sm
        font-medium text-red-700 rtl:left-4 rtl:right-auto
      "
      onClick={onRetry}
      type="button"
    >
      <ExclamationCircleIcon className="h-5 w-5" />
      <p className="flex-start flex flex-col">
        <span className="mx-1">
          <Text text={translations.uploadModalContent.uploadFailed} />
        </span>
        <span className="mx-1 text-xs text-red-900">
          <Text text={error || 'Something went wrong'} />
        </span>
      </p>
    </button>
  );
}
